import { Pipe, PipeTransform } from '@angular/core';
import { WORKFLOW_TRIGGERS } from './trigger-definitions';

@Pipe({ name: 'getWorkflowTriggerKey', standalone: true })
export class GetWorkflowTriggerKeyPipe implements PipeTransform {
  transform(taskDefinitionId: string): string {
    return WORKFLOW_TRIGGERS[taskDefinitionId]?.name;
  }
}
